




















import TopicsCondition from './TopicsCondition'
import { InputSetups } from '@/mixins/input-setups'
import GroupTopicsMixin from "@/mixins/GroupTopicsMixin";

import BlackWhiteListInput from 'piramis-base-components/src/components/Pi/fields/BlackWhiteListInput/BlackWhiteListInput.vue'
import { BlackWhiteListItem } from 'piramis-base-components/src/components/BlackWhiteList/types';
import { ChipsInputTabs } from 'piramis-base-components/src/components/Pi/fields/ChipsInput/types'

import { ValidationObserver } from 'vee-validate'
import { Component, Mixins, VModel } from 'vue-property-decorator'

@Component({
  data() {
    return {
      ChipsInputTabs
    }
  },
  components: {
    ValidationObserver,
    BlackWhiteListInput
  }
})
export default class TopicsConditionView extends Mixins(InputSetups, GroupTopicsMixin) {
  @VModel() model!: TopicsCondition

  get topicsInput() {
    const fr: BlackWhiteListItem<string> = {
      items: this.model.values.items.map(v => v.toString()),
      type: this.model.values.type
    }

    return fr
  }

  set topicsInput(data) {
    this.model.values = {
      items: data.items.reduce((acc: Array<number>, value) => {
        const tryNum = Number.parseInt(value)

        if (!Number.isNaN(tryNum)) {
          acc.push(tryNum)
        }

        return acc
      }, []),
      type: data.type
    }
  }
}
